const TriangleIcon = ({ size = 16, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2681 3C11.0379 1.66667 12.9624 1.66667 13.7322 3L22.3925 18C23.1623 19.3333 22.2 21 20.6604 21H3.3399C1.8003 21 0.838047 19.3333 1.60785 18L10.2681 3ZM12.0002 4L3.3399 19H20.6604L12.0002 4Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default TriangleIcon